var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailTooltipIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    y: 0.148438,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#4096C2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 6.14844H14.5C14.7761 6.14844 15 6.34742 15 6.59288V13.704C15 13.9495 14.7761 14.1484 14.5 14.1484H5.5C5.22386 14.1484 5 13.9495 5 13.704V6.59288C5 6.34742 5.22386 6.14844 5.5 6.14844ZM14 8.03196L10.0359 11.1875L6 8.02219V13.2595H14V8.03196ZM6.25573 7.03733L10.031 9.99822L13.7505 7.03733H6.25573Z",
    fill: "#4096C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailTooltipIcon);
export default __webpack_public_path__ + "static/media/Email-Tooltip-Icon.96a1a51cd30e74742e29716714ae534d.svg";
export { ForwardRef as ReactComponent };